import axios from "axios";

const BASE = "https://us-central1-inprojuy-f1173.cloudfunctions.net/app";

function extraerMensajeError(err) {
  const status = err?.response?.status;
  const data = err?.response?.data;

  if (!err?.response) {
    return "No se pudo conectar con el servidor. Verificá tu conexión e intentá de nuevo.";
  }
  if (status === 500) {
    // S9: el 500 no trae detalle del servidor, no hay nada que mostrar salvo un texto propio.
    return "Ocurrió un error interno. Por favor, intentá de nuevo más tarde.";
  }
  if (data?.message) {
    return data.message;
  }
  return "Ocurrió un error. Por favor, intentá de nuevo.";
}

/**
 * Envía el formulario de Contacto público.
 * @param {{nombre:string, apellido:string, email:string, telefono:string, localidad:string, mensaje:string}} datos
 * @returns {Promise<{ok:boolean}>}
 */
export async function enviarContactoPublico(datos) {
  try {
    const response = await axios.post(`${BASE}/api/publico/contacto`, {
      nombre: datos.nombre,
      apellido: datos.apellido,
      email: datos.email,
      telefono: datos.telefono,
      localidad: datos.localidad,
      mensaje: datos.mensaje,
    });
    return response.data;
  } catch (err) {
    throw new Error(extraerMensajeError(err));
  }
}

/**
 * Envía el formulario de Denuncias público (multipart).
 * @param {object} datos - campos de texto/booleanos de formValues en Denuncias.js
 * @param {{fotoLugar?: File|null, fotoSitio?: File|null}} archivos
 * @returns {Promise<{ok:boolean, id:string, avisoEnviado?:boolean}>}
 */
export async function enviarDenunciaPublica(datos, archivos = {}) {
  const formData = new FormData();

  const camposTexto = [
    "email",
    "telefono",
    "direccion",
    "localidad",
    "direccionlugar",
    "entrecalles",
    "pagina",
    "redsocial",
    "otro",
  ];
  camposTexto.forEach((campo) => {
    if (datos[campo]) {
      formData.append(campo, datos[campo]);
    }
  });

  ["asistiallugar", "aposte", "recibicomprobante"].forEach((campo) => {
    formData.append(campo, String(!!datos[campo]));
  });

  if (archivos.fotoLugar) {
    formData.append("fotoLugar", archivos.fotoLugar);
  }
  if (archivos.fotoSitio) {
    formData.append("fotoSitio", archivos.fotoSitio);
  }

  try {
    const response = await axios.post(`${BASE}/api/publico/denuncias`, formData);
    return response.data;
  } catch (err) {
    throw new Error(extraerMensajeError(err));
  }
}
